// extracted by mini-css-extract-plugin
export var wrap = "controls-module--wrap--1fkxF";
export var sine = "controls-module--sine--32asp";